<template>
    <div>
        <h2 class="text-28 lg:text-36 text-navy font-bold mt-10 mb-2" id="terms">
            TruckersReport LLC Sales Agreement
        </h2>

        <div class="bg-white shadow p-6 tr-box flex flex-col gap-4">
            <div v-html="agreement"></div>

            <form class="mt-4 flex flex-col gap-2" method="post" @submit.prevent="submit">
                <div>
                    <div class="text-base text-gray-500">Your Name</div>
                    <input class="text-xl px-4 py-2 outline border border-navy rounded-md" type="text" name="name"
                        required v-model="name"
                    >
                </div>
                <div>
                    <div class="text-base text-gray-500">Your Title</div>
                    <input class="text-xl px-4 py-2 outline border border-navy rounded-md" type="text" name="title"
                        required v-model="title">
                </div>
                <div>
                    <label class="cursor-pointer">
                        <input type="checkbox" name="agreed" required>
                        <b>I agree to Truckersreport Terms and Conditions</b>
                    </label>
                </div>
                <div class="mt-2">
                    <button class="cursor-pointer bg-navy text-lg px-4 py-2 text-white rounded-md">
                        <i v-if="loading" class="fa fa-fw fa-spinner fa-spin"></i>
                        {{ text }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            required: true
        },
        selectedOption: {
            type: Number
        },
    },
    data() {
        return {
            name: '',
            title: '',
            loading: false,
            text: 'Sign Sales Agreement',
            pusher: {
                public: null,
            }
        }
    },
    computed: {
        selectedPrice() {
            if (this.selectedOption === 1) {
                return this.data.pricing_option1.price;
            }
            if (this.selectedOption === 3) {
                return this.data.pricing_option3.price;
            }

            return this.data.pricing_option2.price;
        },
        firstPaidMonth() {
            let breakingDay = 15;
            let renewalType = this.data.billing.renewal_type;

            // if it is the Friday 14th, we will keep this month as trial as well
            if (moment().date() == 14 && moment().weekday() == 5) {
                breakingDay = 14;
            }

            if (renewalType == 0 && moment().date() < breakingDay) {
                // new business
                return moment().startOf('month');
            } else if (renewalType == 1 || (renewalType == 0 && moment().date() >= breakingDay)) {
                // renewal -> next month
                return moment().add(1, 'months').startOf('month');
            } else if (renewalType == 2) {
                // renewal -> this month
                return moment().startOf('month');
            }
        },
        firstPaidMonthFriendly() {
            if(this.firstPaidMonth) {
                return this.firstPaidMonth.format("MMMM YYYY");
            }

            return null;
        },
        firstPaidMonthNormalized() {
            if(this.firstPaidMonth) {
                return this.firstPaidMonth.format("YYYY-MM-DD");
            }

            return null;
        },
        agreement() {
            let agreement = this.data.proposal_document.sections.agreement.content;

            // when doing changes to the variables below, please be sure to update the PDF proposal too
            agreement = agreement.replaceAll('{client}', this.data.header.name);
            agreement = agreement.replaceAll('{price}', this.money(this.selectedPrice));
            agreement = agreement.replaceAll('{term_length}', this.data.billing.term_length);
            agreement = agreement.replaceAll('{first_paid_month}', this.firstPaidMonthFriendly);

            return agreement;
        }
    },
    methods: {
        submit() {
            this.loading = true;
            this.text = 'Signing';

            this.sign();
        },
        sign() {
            axios.post(url(`sales-proposal/${this.data.proposal.key}/sign`), {
                name: this.name,
                title: this.title,
                agreed: true,
                option: this.selectedOption,
                price: this.selectedPrice,
                first_paid_month: this.firstPaidMonthNormalized,
            }).catch(() => {
                window.location.href = url(`sales-proposal/${this.data.proposal.key}`);
            });
        }
    },
    created() {
        this.pusher.public = Echo.channel(`public`);
        this.pusher.public.listen('.portal-ready', (event) => {
            if (event.identifier == this.data.proposal.key) {
                this.loading = false;
                this.text = 'Signed';
                window.location.href = event.redirect_url;
            }
        });
    },
    beforeDestroy() {
        this.pusher.public.stopListening('.portal-ready');
    }
}
</script>